<div>
	<div>
		<!-- <button *ngIf="userService.hasAccessFunction('act_admin_device_management')" class="btn btn-primary mb20" type="button" (click)="editPolarLinkBtn(0, owners.customerid, owners.siteid)">
			Add New <span class="glyphicon glyphicon-plus"></span>
		</button> -->

        <app-manage-device-btn [selectedDevices]="selectedDevices" [type]="'plink'" *ngIf="!userService.hasAccessFunction('no_manage_devices')" manageChargerBtnMarginClass="button-btm-20" manageChargerDatesBtnMarginClass="button-btm-20"></app-manage-device-btn>
		<!-- <button *ngIf="owners.siteid == 554" class="btn btn-warning mb20" (click)="assignBattviewsToEastPenn()" [disabled]="selectedDevices.length == 0">
			Assign to "East Penn"
		</button> -->

		<!-- <button *ngIf="userService.hasAccessFunction('act_admin_device_management')" 
		class="btn btn-default mb20" type="button"
		[disabled]="selectedDevices.length == 0"
		(click)="autoCorrectBattview(selectedDevices)">
			{{'device.auto_correct' | translate}}
		</button> -->
	</div>

	<div class="boxs">
		<!-- <div *ngIf="pageName != 'listing'">
			<label for="dealer">Select Dealer <select class="form-control inline-form-control" [(ngModel)]="dealerId" (ngModelChange)="changeDealer()" style="display: inline;margin-left: 10px;">
					<option *ngFor="let dealer of dealers" [value]="dealer.id">{{dealer.name}}</option>
				</select>
			</label>
		</div> -->
		<table class="table table-stripped">
			<thead>
				<tr>
					<th *ngIf="owners.siteid == 554 || !userService.hasAccessFunction('no_manage_devices')"><input type="checkbox" [ngModel]="selectAllDevices" (ngModelChange)="selectAllToggle($event)"/> Select All</th>
					<th class="red-text">ActView ID</th>
					<th>Serial Number</th>
					<th *ngIf="pageName == 'unassignedSite'">Customer Name</th>
					<th>PolarLink ID</th>
					<th *ngIf="pageName != 'listing'">Model</th>
					<th *ngIf="pageName == 'listing'">Modification Date</th>
					<th *ngIf="pageName != 'listing'">Installation Date</th>
					<th>Action</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let polarlink of devices">
					<td *ngIf="owners.siteid == 554 || !userService.hasAccessFunction('no_manage_devices')"><input (ngModelChange)="toggleDeviceSelection($event, polarlink)" type="checkbox" class="form-control" [checked]="polarlink.checked" ngModel/></td>
					<td class="red-text">{{polarlink.id}}</td>
					<td>{{polarlink.serialnumber}}</td>
					<td *ngIf="pageName == 'unassignedSite'">{{polarlink.customername}}</td>
					<td>{{polarlink.rseid}}</td>
					<td *ngIf="pageName != 'listing'">{{polarlink.model}}</td>
					<td *ngIf="pageName == 'listing'">{{polarlink.modificationdate | date:'MM/dd/yyyy'}}</td>
					<td *ngIf="pageName != 'listing'">{{polarlink.installationdate | date:'MM/dd/yyyy'}}</td>
					<td>
						<div class="btn-group" appDropdown>
							<i type="button" class="glyphicon glyphicon-cog dropdown-toggle" dropdown-toggle></i>
							<ul class="dropdown-menu" role="menu">
								<li><a (click)="editPolarLinkBtn(polarlink.id, polarlink.customerid, polarlink.siteid)">Edit</a></li>
								<li *ngIf="pageName == 'listing' && userService.hasAccessFunction('act_admin_device_management')"><a (click)="deletePolarLink(polarlink.id)">Delete</a></li>
								<li *ngIf="pageName != 'listing' && pageName != 'battviewMobile' && userService.hasAccessFunction('enable_full_access_mode')"><a (click)="autoCorrectBattview(polarlink.id)">{{'device.auto_correct' | translate}}</a></li>
							</ul>
						</div>
					</td>
				</tr>	
			</tbody>
		</table>
	</div>
</div>